<template>
  <div>
    <div v-if="success">
      {{ $t('signup-success' )}}
    </div>
    <div v-if="success === false">
      {{ $t('signup-unsuccessful') }}
    </div>
    <div v-if="!success">
      <b-form @submit.stop.prevent="signUp">
        <b-form-group>
          <b-form-input type="text" v-model="form.email" :placeholder="$t('login.email')">
          </b-form-input>
          <b-form-input type="password" v-model="form.password" :placeholder="$t('login.password')" class="mt-4">
          </b-form-input>
          <b-form-input type="text" v-model="form.name" :placeholder="$t('name')" class="mt-4">
          </b-form-input>
          <b-form-input type="text" v-model="form.surname" :placeholder="$t('surname')" class="mt-4">
          </b-form-input>
          <b-form-select v-model="form.rol" :options="availableRoles" class="mt-4"></b-form-select>
          <b-form-row class="mt-4">
            <b-col><b-form-input type="text" v-model="form.dni" :placeholder="$t('national-identity-document')">
            </b-form-input></b-col>
            <b-col><b-form-input type="text" v-model="form.phone" :placeholder="$t('phone')">
            </b-form-input></b-col>
          </b-form-row>
          <b-button variant="primary" type="submit" class="w-100 mt-4">{{ $t('sign-up') }}</b-button>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormRow,
    BCol,
    BButton
  },
  data () {
    return {
      success: null,
      form: {
        email: null,
        password: null,
        name: null,
        surname: null,
        dni: null,
        phone: null,
        rol: null
      },
      availableRoles: [
        { value: null, text: this.$t('select-an-option'), disabled: true },
        { value: 'Professional', text: this.$t('professional') },
        { value: 'Patient', text: this.$t('patient') },
        { value: 'Patient', text: this.$t('center') }
      ]
    }
  },
  methods: {
    signUp () {
      this.$userApi.post('Cognito/SignUp', {
        email: this.form.email,
        password: this.form.password,
        given_name: this.form.name,
        family_name: this.form.surname,
        national_identity: this.form.dni,
        phone_number: this.form.phone,
        rol: this.form.rol
      }).then((response) => {
        if (response.data.data) {
          this.success = true
        }
      }).catch((error) => {
        if (error) {
          this.success = false
        }
      })
    }
  }
}
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// src/components/public/account/SignUpCognito.vue